import { Injectable } from '@angular/core';
// import { Http, Headers, RequestOptions, Response, ResponseContentType, URLSearchParams } from '@angular/http';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { Project, Country, Partner, Year, Subject, User, Role } from '../../../projectmanagement/src/app/model/project.model';

import { environment } from '../../../../src/environments/environment';

@Injectable()
export class UserManagementService {
    headers: any;
    options: any;

    constructor( private http: HttpClient) {
        const headersItem = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'CTL ' + localStorage.getItem('token')
        });
        this.headers = headersItem;
    }

    list(): Observable<Project[]> {
        // add header
        this.options = {headers: this.headers};
        // get users from ap
        return this.http.get(environment.restAPI + 'users', this.options)
            .pipe(map((response: any) => {return response; }));
    }

    detail(user_id: string): Observable<Project> {
        // add header
        this.options = {headers: this.headers};
        // get users from ap
        return this.http.get(environment.restAPI + 'user/' + user_id, this.options)
            .pipe(map((response: any) => response.json()[0]));
    }

    search(filter: any): Observable<User[]> {
        let params = new HttpParams();

        for (const prop in filter) {
            if (prop){
                params = params.set(prop, filter[prop]);
            }
        }

        this.options = {headers: this.headers, params};
        return this.http.get(environment.restAPI + 'users', this.options)
            .pipe(map((response: any) => response));
    }

    downloadUserList(type: string, filter: any): Observable<Blob> {
        let params = new HttpParams();
        for (const prop in filter) {
            if (prop){
                params = params.set(prop, filter[prop]);
            }
        }
        params = params.set('action', 'download');
        params = params.set('report', type);
        this.options = { headers: this.headers, responseType: Blob, params};
        return this.http.get(environment.restAPI + 'users', this.options)
            .pipe(map((response: any) => response.blob()));
    }


    disable(user_id: string) {
        // add header

        this.options = {headers: this.headers};
        // get users from ap
        let body: any = {'active': false};
       // alert("service disable called user_id="+user_id+ " status="+JSON.stringify(body));
        return this.http.put(environment.restAPI + 'user/' + user_id, body, this.options)
            .pipe(map((response: any) => response));
    }

    enable(user_id: string) {
            // add header
        this.options = {headers: this.headers};
        // get users from ap
        let body: any = {'active': true};
       // alert("service enable called user_id="+user_id+ " status="+JSON.stringify(body));

        return this.http.put(environment.restAPI + 'user/' + user_id, body, this.options)
            .pipe(map((response: any) => response));
    }

    resetuserpass(user_id: string, data: any) {
        // add header
        this.options = {headers: this.headers};
        // get users from ap
        let body: any = data;
        return this.http.put(environment.restAPI + 'user/' + user_id, body, this.options)
            .pipe(map((response: any) => response));
    }

    create(data: any) {
        // add authorization header with jwt token
        this.headers.append('Accept', 'application/json');
        // add header
        this.options = {headers: this.headers};

        return this.http.post(environment.restAPI + 'user', data, this.options)
            .pipe(map((response: any) => response));
    }

    update(user_id: string, data: any) {
        // add authorization header with jwt token
        this.headers.append('enctype', 'multipart/form-data');
        this.headers.append('Accept', 'application/json');
        // add header
        this.options = {headers: this.headers};

        return this.http.put(environment.restAPI + 'user/' + user_id, data, this.options)
            .pipe(map((response: any) => response));
    }
    allowAccess(user_id: string, data: any) {
        // add authorization header with jwt token
        this.headers.append('enctype', 'multipart/form-data');
        this.headers.append('Accept', 'application/json');
        // add header
        this.options = {headers: this.headers};

        return this.http.put(environment.restAPI + 'user/registration/approve/' + user_id, data, this.options)
            .pipe(map((response: any) => response));
    }
    denyAccess(user_id: string){
        // add header
        this.headers.append('enctype', 'multipart/form-data');
        this.headers.append('Accept', 'application/json');
        // add header
        this.options = {headers: this.headers};
        return this.http.delete(environment.restAPI + 'user/registration/deny/' + user_id, this.options)
            .pipe(map((response: any) => {return response; }));
    }
    listRoles(): Observable<Role[]> {
        // add header
        this.options = {headers: this.headers};
        // get users from ap
        return this.http.get(environment.restAPI + 'roles', this.options)
            .pipe(map((response: any) => response));
    }

    generateLogin(data: any) {
        // add authorization header with jwt token
        this.headers.append('Accept', 'application/json');
        // add header
        this.options = {headers: this.headers};

        return this.http.post(environment.restAPI + 'user/generate/login', data, this.options)
            .pipe(map((response: any) => response));
    }

    enrollArchiveService(){
        alert("toggle service called");
        this.options = {headers: this.headers};
        // get users from ap
        let body: any = {'active': true};
       // return this.http.put(environment.restAPI + 'user/enrollorarchive/' + user_id, body, this.options)
         //   .map((response: Response) => response.json());
    }

}
